import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const getDetailRecruitmentSlice = createSlice({
  name: "getDetailRecruitment",
  initialState,
  reducers: {
    getDetailRecruitmentStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getDetailRecruitmentSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    getDetailRecruitmentFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  getDetailRecruitmentStart,
  getDetailRecruitmentSuccess,
  getDetailRecruitmentFailed,
} = getDetailRecruitmentSlice.actions;

export default getDetailRecruitmentSlice.reducer;
